import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Layout, Row, Col, Spin, Card, Select, Button, DatePicker } from "antd";
import { useEffect, useState } from "react";
import { API } from "aws-amplify";

const { Content } = Layout;
const Option = Select.Option;
const ButtonGroup = Button.Group;

const ItemActionsReport = () => {
  const history = useHistory();
  const hotels = useSelector((state) => state.auth.hotels ?? []);

  const [hotelsOptions, setHotelsOptions] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [dateOptions, setDateOptions] = useState([]);
  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [selectedToDate, setSelectedToDate] = useState(null);
  const [loading, setLoading] = useState(false);

  const [timestamps, setTimestamps] = useState([]);


  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (selectedHotel != null) {
      getTimestamps();
    }
  }, [selectedHotel]);

  const loadData = () => {
    setLoading(true);

    // HOTELS
    var enabledHotels = [];
    for (var i in hotels) {
      enabledHotels.push(<Option key={i}>{hotels[i]}</Option>);
    }
    setHotelsOptions(enabledHotels);

    setLoading(false);
  };

  const getTimestamps = async () => {
    setLoading(true);

    API.get("benackoAPI", "/v2/reports/inventories/balances/headers?hotelId=" + selectedHotel)
        .then(res => {
          const options = [];

          res.forEach(ts => {
            const timestampStr = String(ts);
            const timestamp = (timestampStr.length <= 8) ? setDate(timestampStr) : new Date(ts);
            
            const processedValue = (timestampStr.length <= 8) ? timestamp.getTime() : ts;
            const processedTimestamp = timestamp.toLocaleDateString() + ' ' + timestamp.toLocaleTimeString();
            options.push(
              <Option key={processedValue}>{processedTimestamp}</Option>
            );
          });

          setTimestamps(options);
        })
        .catch((err) => console.log("Error getting hours for shift balances", err))
        .finally(() => setLoading(false));
  };

  const setDate = (dateString) => {
    const beautifiedDate = dateString.split("-").join("");
    const year = parseInt(beautifiedDate.substring(0, 4), 10);
    const month = parseInt(beautifiedDate.substring(4, 6), 10) - 1;
    const day = parseInt(beautifiedDate.substring(6, 8), 10);

    return new Date(year, month, day, 7, 0, 0, 0);
  };

  const goToItemActionsReport = () => {
    history.push(
      "/app/reports/itemactionsreport/" +
        selectedHotel +
        "/" +
        selectedFromDate +
        "/" +
        selectedToDate
    );
  };

  const goToItemActionsSnapshot = () => {
    history.push("/app/reports/itemactionssnapshot/" + selectedHotel);
  };

  return (
    <Layout>
      <Content style={{ margin: 0, padding: 0, background: "#fff" }}>
        <Spin spinning={loading} size="large">
          <Card
            loading={false}
            bordered={false}
            title="Reporte de cantidades - Artículos"
          >
            <Row style={{ marginTop: 30 }}>
              <Col span={4} offset={2}>
                <p>Hotel:</p>
              </Col>
              <Col span={10} offset={2}>
                <Select
                  onChange={(e) => setSelectedHotel(e)}
                  style={{ width: "100%" }}
                >
                  {hotelsOptions}
                </Select>
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col span={4} offset={2}>
                <p>Fecha inicial:</p>
              </Col>
              <Col span={10} offset={2}>
              <Select style={{width: '100%'}} onChange={e => setSelectedFromDate(e)}>{timestamps}</Select>
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col span={4} offset={2}>
                <p>Fecha final:</p>
              </Col>
              <Col span={10} offset={2}>
              <Select style={{width: '100%'}} onChange={e => setSelectedToDate(e)}>{timestamps}</Select>
              </Col>
            </Row>
            <Row style={{ marginTop: 40 }}>
              <Col span={20} offset={2}>
                <ButtonGroup>
                  <Button
                    type="primary"
                    onClick={() => goToItemActionsReport()}
                    disabled={
                      !selectedHotel ||
                      !selectedFromDate ||
                      !selectedToDate ||
                      selectedFromDate > selectedToDate
                    }
                  >
                    Ver reporte
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>


            <Row style={{ marginTop: 40 }}>
              <Col span={20} offset={2}>
                <ButtonGroup>
                  <Button
                    type="primary"
                    onClick={() => goToItemActionsSnapshot()}
                    disabled={!selectedHotel}
                  >
                    Captura de inventario
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Card>
        </Spin>
      </Content>
    </Layout>
  );
};

export default ItemActionsReport;
